module.exports = __webpack_public_path__ + "static/img/xin4.1746f1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/xin4.jpg
// module id = KC+Y
// module chunks = 0